import { observer } from "mobx-react";
import { Case, CaseStatus } from "../../stores/CaseStore/types";
import {
  Alert,
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
} from "@mui/material";
import useTranslation from "../../hooks/useTranslation";
import caseStore from "../../stores/CaseStore";
import { useState } from "react";
import { useNavigate } from "react-router-dom";

export const UpdateCaseStatus = observer(
  ({
    caseItem,
    onUpdate,
  }: {
    caseItem: Case;
    onUpdate?: (status: CaseStatus) => void;
  }) => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);
    const [dialogOpen, setDialogOpen] = useState(false);

    const beforeUpdate = () => {
      setLoading(true);
    };

    const afterUpdate = () => {
      setLoading(false);
      caseStore.fetchUserCases();
      navigate("/cases");
    };

    const handleDeactivate = () => {
      setDialogOpen(true);
    };

    const deactivateConfirm = async () => {
      beforeUpdate();
      await caseStore.deactivateCase(caseItem.id);
      onUpdate?.(CaseStatus.DEACTIVE);
      afterUpdate();
    };

    return (
      <>
        <div className="mb">
          {caseItem?.status === CaseStatus.ACTIVE && (
            <Button
              variant="contained"
              color="error"
              disabled={loading}
              onClick={handleDeactivate}
            >
              {loading ? <CircularProgress size={"16px"} /> : t("deactivate")}
            </Button>
          )}
          {caseItem?.status === CaseStatus.PENDING && (
            <Button disabled={true} variant="contained">
              {t("pending")}
            </Button>
          )}
          {caseItem?.status === CaseStatus.REJECTED && (
            <Alert severity="error">{caseItem.rejectReason}</Alert>
          )}
        </div>
        <Dialog
          open={dialogOpen}
          onClose={() => setDialogOpen(false)}
          className="adminCaseItemDialog"
        >
          <DialogActions className="dialogActions">
            <Button onClick={() => setDialogOpen(false)} color={"error"}>
              &times;
            </Button>
          </DialogActions>
          <DialogContent className="pt mt">
            <p>{t("deactivation-warning")}</p>
            <div className="mt">
              <Button
                variant="contained"
                onClick={deactivateConfirm}
                disabled={loading}
              >
                {t("confirm")}
              </Button>
            </div>
          </DialogContent>
        </Dialog>
      </>
    );
  }
);
